'use strict';


export let clickOutside:any[] = ['$document', '$timeout', '$window', ($document, $timeout, $window) => {
    class ClickOutDirective {
        restrict = 'A';
        scope = {
            ngClickOutside: '&'
        };

        link($scope, elem, attr) {
            // debug
            $window.ngOutsideRegistered = $window.ngOutsideRegistered ? $window.ngOutsideRegistered + 1 : 1;

            var classList = (attr.ngOutsideIfNot !== undefined) ? attr.ngOutsideIfNot.replace(', ', ',').split(',') : [];
            if (attr.id !== undefined) classList.push(attr.id);

            var outsideClickHandler = (e) => {
                var i = 0,
                    element;

                if (!e.target) return;

                if (classList.length) {
                    for (element = e.target; element; element = element.parentNode) {
                        var id = element.id;
                        var classNames = element.className;

                        if (id !== undefined) {
                            for (i = 0; i < classList.length; i++) {
                                if (id.indexOf(classList[i]) > -1 || classNames.indexOf(classList[i]) > -1) {
                                    return;
                                }
                            }
                        }
                    }
                }

                $timeout(function () {
                    $scope.$apply($scope.ngClickOutside());
                });
            };

            $document.on('click touchstart', outsideClickHandler);

            $scope.$on('$destroy', function () {
                $window.ngOutsideRegistered--;
                $document.off('click touchstart', outsideClickHandler);
            });
        }
    }

    return new ClickOutDirective();
}];



// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/click-outside.directive.ts